module.exports = __webpack_public_path__ + "img/epr@2x.3ee60d11.jpeg";